// extracted by mini-css-extract-plugin
export default {"strip":"MKruG6","header":"kLSruZ","title":"nhqKkk","currentPlan":"nIFFeR","currentPlanName":"MXFOVi"};